@if(device) { @if (withState && (device?.paused ?? null) !== undefined &&
(device?.state?.working ?? null) !== undefined) {
<div
  class="status"
  [class.without-icon]="!withIcon"
  [class.paused]="device?.paused"
  [class.working]="!device?.paused && device?.state?.working"
  [class.stopped]="
    !device?.paused &&
    !device?.state?.working &&
    device?.state?.stopped !== false
  "
  [class.broken]="
    !device?.paused &&
    !device?.state?.working &&
    device?.state?.stopped === false
  "
></div>
} @if (device?.icon && withIcon) {
<img [src]="device?.icon?.url ?? ''" />
}
<div
  class="name-and-number"
  [class.clickable]="!!path"
  [class.without-icon]="!withIcon"
>
  @if (siteName) {
  <p
    class="site-name"
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [data]="[siteName, fullAddress || '']"
    (click)="navigateToProvidedPath($event)"
  >
    {{ siteName }}
  </p>
  }
  <p
    class="name"
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[device?.name ?? '']"
    (click)="navigateToProvidedPath($event)"
  >
    {{ device?.name }}
  </p>
  <p
    class="number"
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[device?.deviceNumber ?? '']"
    (click)="navigateToProvidedPath($event)"
  >
    {{ device?.deviceNumber }}
  </p>
</div>
} @else { --- }
